var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParkingInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 175,
    viewBox: "0 0 175 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_235_3796)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.4859 174.972C135.803 174.972 174.972 135.803 174.972 87.4859C174.972 39.1688 135.803 0 87.4859 0C39.1688 0 0 39.1688 0 87.4859C0 135.803 39.1688 174.972 87.4859 174.972Z",
    fill: "#EA3E10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0077 161.053C129.64 160.209 161.894 126.586 161.05 85.9545C160.206 45.3227 126.583 13.0683 85.9513 13.9123C45.3195 14.7563 13.0651 48.3791 13.9091 89.011C14.7531 129.643 48.3759 161.897 89.0077 161.053Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0108 103.782V138.179H57.8257V40.4584H89.6567C96.1977 40.4584 101.836 41.2196 106.629 42.7703C111.394 44.2928 115.341 46.4355 118.471 49.1985C121.572 51.9333 123.884 55.232 125.378 59.0664C126.873 62.9008 127.606 67.1017 127.606 71.6409C127.606 76.1801 126.816 80.7194 125.237 84.6665C123.659 88.6137 121.29 91.997 118.133 94.8445C114.975 97.6921 111.028 99.8913 106.291 101.47C101.555 103.049 96.0285 103.838 89.6567 103.838H76.0108V103.782ZM76.0108 89.5723H89.6567C92.9836 89.5723 95.8875 89.1494 98.3686 88.3317C100.85 87.5141 102.908 86.3018 104.515 84.7511C106.15 83.2004 107.362 81.3114 108.152 79.0841C108.97 76.8568 109.364 74.3757 109.364 71.6127C109.364 68.8497 108.97 66.6224 108.152 64.5078C107.334 62.3933 106.122 60.5889 104.515 59.0946C102.88 57.6003 100.85 56.4726 98.3686 55.6831C95.8875 54.8937 92.9836 54.499 89.6567 54.499H76.0108V89.5723Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8592 21.0429L23.6841 32.3949L143.433 150.277L154.608 138.925L34.8592 21.0429Z",
    fill: "#EA3E10"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4859 65.2409C116.751 65.2409 143.93 59.4893 166.401 49.6496C152.304 20.2715 122.277 0 87.4859 0C52.6945 0 22.6961 20.2715 8.59912 49.6496C31.0697 59.4893 58.2205 65.2409 87.5141 65.2409H87.4859Z",
    fill: "#545454"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_235_3796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 175,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingInactive);
export default __webpack_public_path__ + "static/media/parking_inactive.d868aabf5fefd0231b69c96d122e503f.svg";
export { ForwardRef as ReactComponent };